import loadable from '@loadable/component';

export const CreateJobPageContainerLoadable = loadable(
  () => import('./CreateJobPageContainer'),
  { resolveComponent: (module) => module.CreateJobPageContainer },
);
